import { FileText } from 'lucide-react';

const termsSections = [
  {
    title: '1. Definities',
    paragraphs: [
      { label: 'Dgitaal:', text: 'Dgitaal, gevestigd te Gaston Crommenlaan 8, 9050 Gent, Belgie, met ondernemingsnummer BE 1002.587.545' },
      { label: 'Klant:', text: 'De natuurlijke of rechtspersoon die een overeenkomst aangaat met Dgitaal' },
      { label: 'Diensten:', text: 'Alle IT-diensten en -producten die Dgitaal aanbiedt, inclusief maar niet beperkt tot consultancy, managed services, cloud oplossingen, cybersecurity, software ontwikkeling en hardware' },
      { label: 'Overeenkomst:', text: 'Elke schriftelijke of mondelinge afspraak tussen Dgitaal en de Klant' },
    ],
  },
  {
    title: '2. Toepasselijkheid',
    paragraphs: [
      { text: 'Deze algemene voorwaarden zijn van toepassing op alle rechtsverhoudingen tussen Dgitaal en de Klant, tenzij uitdrukkelijk schriftelijk anders is overeengekomen.' },
      { text: 'Afwijkingen van deze voorwaarden zijn slechts geldig indien deze uitdrukkelijk schriftelijk zijn overeengekomen.' },
      { text: 'De toepasselijkheid van eventuele inkoop- of andere voorwaarden van de Klant wordt uitdrukkelijk uitgesloten.' },
    ],
  },
  {
    title: '3. Offertes en Totstandkoming van de Overeenkomst',
    paragraphs: [
      { label: '3.1', text: 'Alle offertes van Dgitaal zijn vrijblijvend en geldig gedurende 30 dagen, tenzij anders vermeld.' },
      { label: '3.2', text: 'Een overeenkomst komt tot stand op het moment dat de Klant de offerte schriftelijk (inclusief e-mail) accepteert, of wanneer Dgitaal op verzoek van de Klant met de uitvoering van de opdracht is begonnen.' },
      { label: '3.3', text: 'Kennelijke fouten of vergissingen in de offerte binden Dgitaal niet.' },
      { label: '3.4', text: 'Prijzen in offertes zijn exclusief BTW en andere heffingen, tenzij anders vermeld.' },
    ],
  },
  {
    title: '4. Uitvoering van de Diensten',
    paragraphs: [
      { label: '4.1', text: 'Dgitaal zal de overeenkomst naar beste inzicht en vermogen en overeenkomstig de eisen van goed vakmanschap uitvoeren.' },
      { label: '4.2', text: 'Dgitaal heeft het recht om werkzaamheden te laten verrichten door derden.' },
      { label: '4.3', text: 'De Klant draagt er zorg voor dat alle gegevens, waarvan Dgitaal aangeeft dat deze noodzakelijk zijn of waarvan de Klant redelijkerwijs behoort te begrijpen dat deze noodzakelijk zijn voor het uitvoeren van de overeenkomst, tijdig aan Dgitaal worden verstrekt.' },
      { label: '4.4', text: 'Levertijden zijn indicatief en gelden niet als fatale termijn, tenzij uitdrukkelijk schriftelijk anders overeengekomen. Bij overschrijding van een levertijd is Dgitaal niet in verzuim en heeft de Klant geen recht op schadevergoeding.' },
      { label: '4.5', text: 'Dgitaal is gerechtigd de overeenkomst in verschillende fasen uit te voeren en het aldus uitgevoerde gedeelte afzonderlijk te factureren.' },
    ],
  },
  {
    title: '5. Prijzen en Betaling',
    paragraphs: [
      { label: '5.1', text: 'Alle prijzen zijn in Euro en exclusief BTW en andere heffingen van overheidswege, tenzij anders vermeld.' },
      { label: '5.2', text: 'Betaling dient te geschieden binnen 30 dagen na factuurdatum, tenzij schriftelijk anders overeengekomen.' },
      { label: '5.3', text: 'Bij niet-tijdige betaling is de Klant van rechtswege in verzuim. De Klant is alsdan een rente verschuldigd van 1% per maand, waarbij een gedeelte van een maand als een hele maand wordt beschouwd.' },
      { label: '5.4', text: 'Bij niet-tijdige betaling zijn tevens alle buitengerechtelijke incassokosten verschuldigd. Deze kosten bedragen minimaal 15% van het openstaande bedrag met een minimum van EUR150.' },
      { label: '5.5', text: 'Dgitaal is gerechtigd om vooruitbetaling of zekerheid te verlangen alvorens tot levering of (verdere) uitvoering over te gaan.' },
      { label: '5.6', text: 'Dgitaal heeft het recht om prijzen jaarlijks aan te passen aan de hand van de CBS prijsindexcijfer.' },
    ],
  },
  {
    title: '6. Wijziging van de Overeenkomst',
    paragraphs: [
      { label: '6.1', text: 'Indien tijdens de uitvoering blijkt dat voor een behoorlijke uitvoering het noodzakelijk is om de te verrichten werkzaamheden te wijzigen of aan te vullen, zullen partijen de overeenkomst tijdig en in onderling overleg dienovereenkomstig aanpassen.' },
      { label: '6.2', text: 'Indien partijen overeenkomen dat de overeenkomst wordt gewijzigd of aangevuld, kan het tijdstip van voltooiing van de uitvoering daardoor worden beinvloed. Dgitaal zal de Klant hiervan zo spoedig mogelijk op de hoogte stellen.' },
      { label: '6.3', text: 'Meerwerk wordt door Dgitaal afzonderlijk gefactureerd.' },
    ],
  },
  {
    title: '7. Intellectuele Eigendomsrechten',
    paragraphs: [
      { label: '7.1', text: 'Alle intellectuele eigendomsrechten met betrekking tot de door Dgitaal ontwikkelde of ter beschikking gestelde materialen, zoals software, ontwerpen, documentatie, rapporten en offertes, berusten uitsluitend bij Dgitaal of haar licentiegevers.' },
      { label: '7.2', text: 'De Klant verkrijgt uitsluitend de gebruiksrechten die expliciet in deze algemene voorwaarden of anderszins schriftelijk worden toegekend.' },
      { label: '7.3', text: 'Het is de Klant niet toegestaan om intellectuele eigendomsrechten te verwijderen of te wijzigen.' },
      { label: '7.4', text: 'Dgitaal mag de kennis die zij opdoet bij de uitvoering van een overeenkomst gebruiken voor andere doeleinden, voor zover hierbij geen vertrouwelijke informatie ter kennis van derden wordt gebracht.' },
    ],
  },
  {
    title: '8. Geheimhouding',
    paragraphs: [
      { label: '8.1', text: 'Beide partijen zijn verplicht tot geheimhouding van alle vertrouwelijke informatie die zij in het kader van hun overeenkomst van elkaar of uit andere bron hebben verkregen.' },
      { label: '8.2', text: 'Informatie geldt als vertrouwelijk als dit door de andere partij is medegedeeld of als dit voortvloeit uit de aard van de informatie.' },
    ],
  },
  {
    title: '9. Aansprakelijkheid',
    paragraphs: [
      { label: '9.1', text: 'Dgitaal is uitsluitend aansprakelijk voor directe schade die het directe gevolg is van een toerekenbare tekortkoming in de nakoming van de overeenkomst.' },
      { label: '9.2', text: 'Dgitaal is nimmer aansprakelijk voor indirecte schade, daaronder begrepen gevolgschade, gederfde winst, gemiste besparingen, schade door bedrijfsstagnatie en schade als gevolg van aanspraken van afnemers van de Klant.' },
      { label: '9.3', text: 'De totale aansprakelijkheid van Dgitaal is beperkt tot het bedrag dat in het desbetreffende geval onder de aansprakelijkheidsverzekering wordt uitbetaald, vermeerderd met het toepasselijke eigen risico. Indien om welke reden dan ook geen uitkering plaatsvindt, is de aansprakelijkheid beperkt tot maximaal het factuurbedrag van de betreffende opdracht (excl. BTW).' },
      { label: '9.4', text: 'Dgitaal is niet aansprakelijk indien de schade het gevolg is van overmacht.' },
      { label: '9.5', text: 'De Klant vrijwaart Dgitaal voor alle aanspraken van derden die verband houden met de door Dgitaal geleverde producten en/of diensten.' },
    ],
  },
  {
    title: '10. Overmacht',
    paragraphs: [
      { label: '10.1', text: 'Dgitaal is niet gehouden tot het nakomen van enige verplichting indien zij daartoe verhinderd is als gevolg van een omstandigheid die niet is te wijten aan haar schuld, noch krachtens wet, rechtshandeling of in het verkeer geldende opvattingen voor haar rekening komt.' },
      { label: '10.2', text: 'Onder overmacht wordt verstaan: elke van de wil van Dgitaal onafhankelijke omstandigheid, waardoor de nakoming van haar verplichtingen jegens de Klant geheel of gedeeltelijk wordt verhinderd. Hieronder vallen onder meer: ziekte van personeel, gebreken aan apparatuur, software of materialen van derden, stroomstoringen, storing van internet, datanetwerk- of telecommunicatiefaciliteiten.' },
      { label: '10.3', text: 'Bij overmacht heeft Dgitaal het recht de uitvoering van de overeenkomst op te schorten dan wel de overeenkomst te ontbinden, zonder dat zij tot enige schadevergoeding gehouden is.' },
    ],
  },
  {
    title: '11. Opschorting en Ontbinding',
    paragraphs: [
      { label: '11.1', text: 'Dgitaal is bevoegd de nakoming van haar verplichtingen op te schorten of de overeenkomst te ontbinden, indien de Klant de verplichtingen uit de overeenkomst niet, niet volledig of niet tijdig nakomt.' },
      { label: '11.2', text: 'Voorts is Dgitaal daartoe bevoegd indien zij na het sluiten van de overeenkomst ter kennis gekomen omstandigheden haar goede grond geven te vrezen dat de Klant de verplichtingen niet zal nakomen.' },
      { label: '11.3', text: 'Indien de overeenkomst wordt ontbonden zijn de vorderingen van Dgitaal op de Klant onmiddellijk opeisbaar.' },
    ],
  },
  {
    title: '12. Toepasselijk Recht en Geschillen',
    paragraphs: [
      { label: '12.1', text: 'Op alle rechtsbetrekkingen waarbij Dgitaal partij is, is uitsluitend het Belgisch recht van toepassing.' },
      { label: '12.2', text: 'Geschillen zullen bij uitsluiting worden voorgelegd aan de bevoegde rechter in het arrondissement waar Dgitaal is gevestigd, tenzij de wet dwingend anders voorschrijft.' },
      { label: '12.3', text: 'Partijen zullen pas een beroep op de rechter doen nadat zij zich tot het uiterste hebben ingespannen een geschil in onderling overleg te beslechten.' },
    ],
  },
  {
    title: '13. Wijziging Algemene Voorwaarden',
    paragraphs: [
      { text: 'Dgitaal behoudt zich het recht voor deze algemene voorwaarden te wijzigen. De meest recente versie is te allen tijde te vinden op onze website. Wijzigingen worden van kracht zodra deze op de website zijn gepubliceerd, tenzij een later tijdstip is vermeld.' },
    ],
  },
];

function Paragraph({ item }) {
  return (
    <p>
      {item.label ? <strong>{item.label} </strong> : null}
      {item.text}
    </p>
  );
}

export default function Voorwaarden() {
  return (
    <div data-testid="voorwaarden-page">
      <section className="relative pt-40 pb-20 overflow-hidden" style={{ background: 'linear-gradient(135deg, #16224b 0%, #233a80 100%)' }}>
        <div className="dot-pattern absolute inset-0" />
        <div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-10 text-center">
          <h1 className="text-white font-bold mb-4" style={{ fontSize: 'clamp(2rem, 4vw, 3rem)', letterSpacing: '-0.03em' }}>Algemene Voorwaarden</h1>
          <p className="text-white/70">Laatst bijgewerkt: 9 mei 2026</p>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6 article-content">
          <p>
            Deze algemene voorwaarden zijn van toepassing op alle aanbiedingen, offertes en overeenkomsten tussen Dgitaal (hierna: "Dgitaal", "wij", "ons") en haar klanten (hierna: "Klant", "u"). Door gebruik te maken van onze diensten, gaat u akkoord met deze voorwaarden.
          </p>

          {termsSections.map((section) => (
            <div key={section.title} className="mb-10">
              <h2>{section.title}</h2>
              {section.paragraphs.map((item, index) => (
                <Paragraph key={`${section.title}-${index}`} item={item} />
              ))}
            </div>
          ))}

          <div className="not-prose rounded-[32px] border border-[#d9deea] bg-[#f8f9fd] p-8">
            <h2 className="text-[#16224b] text-2xl font-bold mb-3">Vragen over onze voorwaarden?</h2>
            <p className="text-[#5f667a] leading-7 mb-6">
              Heeft u vragen over deze algemene voorwaarden? Neem gerust contact met ons op.
            </p>
            <div className="flex flex-wrap gap-4">
              <a href="mailto:hello@dgitaal.be" className="btn-gradient">E-mail ons</a>
              <a href="tel:+32470416675" className="btn-secondary-outline">Bel ons</a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}